export const exponentialBackoff = (toTry, callback, delayFactor = 1.1, delay = 1000) => {
  toTry().then(result => {
    const stop = callback(result)
    if (!stop) {
      return setTimeout(() => {
        exponentialBackoff(toTry, callback, delayFactor, delay * delayFactor)
      }, delay)
    }
    return null
  })
}
